import { useState, useEffect } from "react";
import axios from 'axios';
import { useCti } from "./useCti.ts"
import { jwtDecode } from 'jwt-decode'
import { proxyUrl } from "./Utils.jsx";

// 'Installs' the app by exchanging the authentication code for an access token
function HubspotInstaller(brand) {
    const [status, setStatus] = useState(["Loading.."]);
    const urlParams = new URLSearchParams(window.location.search);

    // Keeps the HubSpot iframe from 'disconnecting' while the app is in the installed screen
    useCti(() => {}, () => {}, () => {});

    useEffect(() => {
        const step = urlParams.get('step');
        const authCode = urlParams.get('code');
        const returnUrl = urlParams.get('returnUrl');
        const state = urlParams.get('state');
        const securityToken = localStorage.getItem("securitytoken");
        const isFinalize = step === "finalize";
        const config = isFinalize ? {} : { headers: { Authorization: `Bearer ${securityToken}` } };
        var authTenant;

        // In the secure flow (step=finalize) the `state` is an opaque, server-stored token,
        // so tenant validation happens on the backend (keyed by that state). The legacy /
        // self-initiated OAuth path instead encodes the tenant into the state as
        // "client2020<uuid>|<tenant>" and validates it client-side here.
        if (!isFinalize && state != null && state != "null") {
            const appTenant = state.split("|")[1];
            authTenant = jwtDecode(securityToken).TenantName;
            if (appTenant != authTenant) {
                const brandName = brand === "bonline" ? "bOnline" : "CloudCTI";
                setStatus(["Tenant mismatch", `A ${brandName} account with a different tenant than the one logged in on the app was used. Please sign out, retry the install link and log in with an account of the same tenant, then try again.`]);
                console.log(`${brandName} account tenant mismatch (${appTenant} and ${authTenant})`);
                axios.get(`https://auth.cloudcti.nl/webapi/OAuth2?state=${state}&code=tenantMismatch`, { timeout: 30000 });
                return;
            }
        }

        // TODO (backend - hubspotservices.cloudcti.nl): for the secure flow, /oAuth MUST
        // first look up the `state` token stored during the authorize step, verify it exists
        // and hasn't expired, delete it (single-use), and only THEN exchange `code` for
        // tokens - associating them with the tenant bound to that state. Reject (non-200) if
        // the state is missing/expired so we redirect back to returnUrl without a login loop.
        axios.post(proxyUrl + "/oAuth", { code: authCode, state: state }, config)
        .then(async (response) => {
            if (response.status != 200)
                throw new Error(await response.text());
            else {
                // The auth.cloudcti.nl polling callback belongs to the manual "Reauthorize"
                // path (a separate tab polls for this result); it isn't used in the secure flow.
                if (!isFinalize && state != null) {
                    axios.get(`https://auth.cloudcti.nl/webapi/OAuth2?state=${state}&code=success`, { timeout: 30000 });
                }
                
                console.log("Authorization complete");
                if (returnUrl != null) { // New install flow with redirect
                    var countdown = 10;
                    var intervalId = setInterval(function(){
                        if (countdown == 0) {
                            clearInterval(intervalId);
                            window.location.href = returnUrl;
                            return;
                        }
                        setStatus(["Installation successful!", "You will be redirected back to HubSpot in " + countdown + " seconds..."]);
                        countdown -= 1;
                    }, 1000);
                }
                else { // Legacy install flow
                    setStatus(["Installation successful!", "You can close this windows now."]);
                }
            }
        }).catch((error) => {
            console.log("Error authorizating app");
            console.log(error);
            var strError;
            if (error.response != undefined)
                strError = error.response.data;
            else
                strError = error.toString();
            if (!isFinalize && state != null)
                axios.get("https://auth.cloudcti.nl/webapi/OAuth2?code=error&state=" + state, { timeout: 30000 });

            setStatus(["Encountered an error while installing:", strError])
        });
    }, []);

    if (status.length == 2)
        return <div style={{ width: "100%", padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>{status[0]}</h2>
            <p style={{ textAlign: "center" }}>{status[1]}</p>
        </div>
    else 
        return <div style={{ width: "100%", padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>{status[0]}</h2>
        </div>
}

export default HubspotInstaller;